import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Slider } from 'infinite-react-carousel';

export function TutorialSlider() {
  const { t } = useTranslation();

  const slides = [
    {
      title: t('tutorialSlider.slide1.title'),
      description: t('tutorialSlider.slide1.desc'),
      image: 'click-mis-dashboards.png',
    },
    {
      title: t('tutorialSlider.slide2.title'),
      description: t('tutorialSlider.slide2.desc'),
      image: 'click-nuevo-dashboard.png',
    },
    {
      title: t('tutorialSlider.slide3.title'),
      description: t('tutorialSlider.slide3.desc'),
      image: 'create-dashboard.png',
    },
    {
      title: t('tutorialSlider.slide4.title'),
      description: t('tutorialSlider.slide4.desc'),
      image: 'select-dashboard.png',
    },
    {
      title: t('tutorialSlider.slide5.title'),
      description: t('tutorialSlider.slide5.desc'),
      image: 'click-editar-dashboard.png',
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <Slider {...settings}>
      {slides.map((slide, index) => (
        <Box key={index} p={3}>
          <Box display="flex" justifyContent="center">
            <img
              src={require(`./imgs/${slide.image}`)}
              alt={slide.title}
              style={{
                maxWidth: '100%',
                maxHeight: 400,
                objectFit: 'contain',
                borderRadius: 8,
              }}
            />
          </Box>
          <Box marginTop={4}>
            <h2>{slide.title}</h2>
            <p>{slide.description}</p>
          </Box>
        </Box>
      ))}
    </Slider>
  );
}
